import { useState } from "react";
import { ArrowDown, ArrowUp, Search, X } from "lucide-react";
import { FilterUpdate } from "@/utils/filter";

const filterOptions = [
  { label: "Status", value: "status_then_date" },
  { label: "Lesson name", value: "lesson_name" },
  { label: "Created date", value: "created_at" },
  { label: "Mastery", value: "mastery" },
];
interface FilterOptionsProps {
  onFiltersChange?: (update: FilterUpdate) => void;
  initialFilter?: string;
  initialSortOrder?: string;
  initialSearchValue?: string;
  excludeOptions?: string[];
  showSortLabel?: boolean;
  searchPlaceholder?: string;
}
export default function FilterOptions({
  onFiltersChange,
  initialFilter = "lesson_name",
  initialSortOrder = "asc",
  initialSearchValue = "",
  excludeOptions = [],
  showSortLabel = false,
  searchPlaceholder = "Search lessons…",
}: FilterOptionsProps) {
  const [currentFilter, setCurrentFilter] = useState(initialFilter);
  const [sortOrder, setSortOrder] = useState(initialSortOrder);
  const [searchValue, setSearchValue] = useState(initialSearchValue);
  const search = (value: string) => {
    setSearchValue(value);
    onFiltersChange?.({ searchValue: value });
  };
  return (
    <div className="et-filters">
      <label className="et-search">
        <Search size={18} aria-hidden="true" />
        <input
          type="search"
          aria-label="Search lessons"
          placeholder={searchPlaceholder}
          value={searchValue}
          onChange={(e) => search(e.target.value)}
        />
        {searchValue && (
          <button
            type="button"
            className="et-icon-button"
            aria-label="Clear search"
            onClick={() => search("")}
          >
            <X size={15} />
          </button>
        )}
      </label>
      <div className="et-sort-controls">
        {showSortLabel && <span className="et-sort-label">Sort by:</span>}
        <select
          aria-label="Sort lessons"
          className="et-sort"
          value={currentFilter}
          onChange={(e) => {
            setCurrentFilter(e.target.value);
            onFiltersChange?.({ filterType: e.target.value });
          }}
        >
          {filterOptions
            .filter((o) => !excludeOptions.includes(o.value))
            .map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
        </select>
        <button
          type="button"
          className="et-icon-button"
          aria-label={
            sortOrder === "asc" ? "Sort descending" : "Sort ascending"
          }
          onClick={() => {
            const next = sortOrder === "asc" ? "desc" : "asc";
            setSortOrder(next);
            onFiltersChange?.({ sortOrder: next });
          }}
        >
          {sortOrder === "asc" ? (
            <ArrowUp size={17} aria-hidden="true" />
          ) : (
            <ArrowDown size={17} aria-hidden="true" />
          )}
        </button>
      </div>
    </div>
  );
}
